export const emailMasterApis = {
    sendMail: 'v1/api/email?from=',
    getTemplates: 'v1/api/emailTemplates',
    createTemplate: 'v1/api/emailTemplates',
    updateTemplate: 'v1/api/emailTemplates?emailTemplatesId=',
    deleteTemplate: 'v1/api/emailTemplates',
    templateById: 'v1/api/emailTemplates',
    getEvenst: 'v1/api/emailEvents',
    createEvents: 'v1/api/emailEvents',
    editEvents: 'v1/api/emailEvents?emailEventsId=',
    deleteEvents: 'v1/api/emailEvents',
    getEmailSubject: 'v1/api/universityEmail/admin?country=',
    sendEMailTemplate: 'v1/api/email/sentEmailTemplate?from=',
    emailTemplateById: 'v1/api/emailTemplates/admin?templateId=',
    checkEligibilityBy: 'v1/api/courses/website/checkEligibilityByApplicationId?applicationId=',
}